import { createContext } from "react";

export interface FHIRContextType {
  client: any | null;
  isLoading: boolean;
  error: string | null;
}

const FHIRContext = createContext<FHIRContextType>({
  client: null,
  isLoading: true,
  error: null,
});

export default FHIRContext;
